import { render, staticRenderFns } from "./CreditBox.vue?vue&type=template&id=40d23287"
import script from "./CreditBox.vue?vue&type=script&lang=js"
export * from "./CreditBox.vue?vue&type=script&lang=js"
import style0 from "./CreditBox.vue?vue&type=style&index=0&id=40d23287&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports